export enum TaskStatusTypeEnum {
  /** Заполнение */
  DRAFT = 'DRAFT',
  /** Запланирован */
  SCHEDULED = 'SCHEDULED',
  /** Согласование */
  ON_APPROVAL = 'ON_APPROVAL',
  /** Согласован */
  AGREED = 'AGREED',
  /** Оплачен */
  PAID = 'PAID',
  /** Недоплата */
  UNDERPAYMENT = 'UNDERPAYMENT',
  /** Переплата */
  OVERPAYMENT = 'OVERPAYMENT',
  /** Отказан */
  REFUSED = 'REFUSED',
  /** Пользовательский дополнительный статус */
  CUSTOM = 'CUSTOM'
}
